import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {Observable, Subject} from 'rxjs';

import {RxComponent} from '../../../shared/components/common/rx.component';
import {UploadService} from '../../services/upload.service';

import {DomainService} from '../../services/domain.service';
import {LicenseService} from '../../services/license.service';
import {AuthService} from '../../services/auth.service';
import {NotificationService} from '../../services/notification.service';
import {SessionService} from '../../services/session.service';

@Component({
  selector: 'itpx-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent extends RxComponent implements OnInit {

  private formSubmit = new Subject<any>();
  private file: File;

  private loading: boolean;

  private status: string = 'ready';
  private errorMessage: string;
  private domain: any;
  private model: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private domainService: DomainService,
    private licenseService: LicenseService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private sessionService: SessionService,
    private uploadService: UploadService
  ) {
    super();
    this.model = {};
  }

  ngOnInit() {
    this.domain = this.domainService.getDomain();
    this.model.domain = this.domain.name;

    this.authService.isAuthenticated$
      .take(1)
      .filter(logged => logged)
      .bindToLifecycle(this)
      .subscribe(_ => this.model.email = this.sessionService.getUserDetails().username);

    this.formSubmit
      .do(_ => this.loading = true)
      .flatMap(_ => this.file ? this.uploadImage() : Observable.of(true))
      .withLatestFrom(this.authService.isAuthenticated$, (fileInfo, isLogged) => ({fileInfo: fileInfo, isLogged: isLogged}))
      .flatMap(data => this.sendSupportTicket(this.model, data.fileInfo, data.isLogged).finally(() => this.loading = false).neverError())
      .bindToLifecycle(this)
      .subscribe(_ => this.model.result = 'Thank you for contacting support. We will help you soon for the problem');
  }

  private uploadImage(): Observable<any> {
    return this.uploadService.getPreSignedToken(this.file)
      .map(body => body.data)
      .neverError(() => this.loading = false)
      .flatMap(token => this.uploadService.uploadContent(this.file, token.fileName).map(f => token.id).neverError(() => this.loading = false))
      .flatMap(fileId => this.uploadService.completeFileDetails(fileId).map(body => body.data).neverError(() => this.loading = false));
  }

  private sendSupportTicket(model: any, fileInfo: any, isLogged: boolean) {
    model.path = fileInfo ? fileInfo.path : '';
    if (isLogged) {
      this.model.email = this.sessionService.getUserDetails().username;
    }

    return isLogged ?
      this.licenseService.supportRequestLearner(model) :
      this.licenseService.supportRequestPublic(model);
  }

  private sendRequest() {
    if (this.loading)
      return

    this.formSubmit.next(true);
  }

  private onFileChange(e: any) {
    this.file = e.srcElement.files[0];
    this.model.file = this.file.name;
    this.model.shortName = this.getShortName(this.file.name);
    const maxFileSize = 5;
    if (maxFileSize && this.file.size > (maxFileSize + 1) * 1024 * 1024) {
      this.notificationService.error(
        'File must be of size max ' + maxFileSize + ' mb',
        'Failed'
      );
    }
  }

  private getShortName(name: string) {
    let lastDotPos = name.lastIndexOf('.');
    let extension = name.substr(lastDotPos + 1);

    let shortName;
    if (lastDotPos > 23) {
      let first = name.substr(0, 20);
      let second = name.substr(lastDotPos - 3, 3);
      shortName = `${first}...${second}`;
    } else {
      shortName = name.substr(0, lastDotPos);
    }

    return `${shortName}.${extension}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/support/support.component.ts